import UltMeta, { Meta } from "./UltMeta/index";
class WarehouseType extends UltMeta {
    QUALIFIED = new Meta(1, "合格品库");
    WASTE_PRODUCTS = new Meta(2, "废品库");
}
export const WAREHOUSE_TYPE = new WarehouseType();

class WarehouseAble extends UltMeta {
    ENABLE = new Meta(0, "启用");
    DISABLE = new Meta(1, "停用");
}

export const WAREHOUSE_ABLE = new WarehouseAble();

class DeviceBindingStatus extends UltMeta {
    UNBOUND = new Meta(0, "否");
    BOUND = new Meta(1, "是");
}

export const DEVICE_BINDING_STATUS = new DeviceBindingStatus();
